// libs
import moment from "moment";
// others
import { HrsolIcons } from "../../icon";
import CONSTANTS from "../../constants";
import { getCurrentBranchJSON } from "../../config";

const {
  VIEW_WORK_SHIFT,
  VIEW_LEAVE_TYPE,
  VIEW_MY_DAILY_REPORT,
  VIEW_ALL_DAILY_REPORT,
  VIEW_DAILY_REPORT,
  VIEW_PAYROLL,
  VIEW_PROFILE,
  VIEW_CALENDAR,
  VIEW_TIME_CHECK,
  VIEW_DASHBOARD,
  VIEW_STATISTIC,
  VIEW_SALARY,
} = CONSTANTS.PRIVILEGE;

const menuSider = ({ t }) => {
  return [
    // Dashboard
    {
      id: "dashboard",
      title: t("t_dashboard"),
      iconSub: HrsolIcons.DashboardIcon,
      privilege: [
        VIEW_DASHBOARD,
        // VIEW_DAILY_ANALYSIS,
        // VIEW_USER_ANALYSIS,
        VIEW_STATISTIC,
        VIEW_SALARY,
      ],
      childMenu: [
        // {
        //   icon: <DailyIcon style={{ marginRight: 10, marginTop: 6 }} />,
        //   itemKey: "dashboard-daily-analysis",
        //   destination: "daily-analysis",
        //   labelLocale: "t_daily_analysis",
        //   privilege: VIEW_DAILY_ANALYSIS,
        //   functionCode: "daily_analyst",
        // },
        // {
        //   icon: <UserAnalysisIcon style={{ marginRight: 10, marginTop: 6 }} />,
        //   itemKey: "dashboard-user-analysis",
        //   destination: "user-analysis",
        //   labelLocale: "t_user_analysis",
        //   privilege: VIEW_USER_ANALYSIS,
        //   functionCode: "user_analyst",
        // },
        {
          itemKey: "dashboard-statistic",
          linkTo: "/dashboard/statistic",
          labelLocale: t("t_statistic"),
          privilege: [VIEW_STATISTIC],
          functionCode: "statistic",
          search: `page=1&size=10&branch=${getCurrentBranchJSON()?.code}&zone=${
            getCurrentBranchJSON()?.zone
          }&fromDate=${moment()
            .startOf("month")
            .format("YYYY-MM-DD")}&toDate=${moment()
            .endOf("month")
            .format("YYYY-MM-DD")}`,
        },
      ],
    },
    // Time
    {
      id: "time",
      title: t("t_attendance"),
      iconSub: HrsolIcons.AttendanceIcon,
      privilege: [VIEW_TIME_CHECK],
      linkTo: "/time",
    },
    // calendar
    {
      id: "calendar",
      title: t("t_calendar"),
      iconSub: HrsolIcons.CalendarIcon,
      privilege: [VIEW_CALENDAR],
      linkTo: "/calendar",
    },
    // Profile
    {
      id: "profile",
      title: t("t_profile"),
      iconSub: HrsolIcons.ProfileIcon,
      privilege: [VIEW_PROFILE, VIEW_LEAVE_TYPE, VIEW_PAYROLL, VIEW_WORK_SHIFT],
      childMenu: [
        {
          itemKey: "profile-worked-shift",
          linkTo: "/profile/worked-shift",
          labelLocale: t("t_worked_shift"),
          privilege: [VIEW_WORK_SHIFT],
          functionCode: "work_shift",
        },
        // {
        //   itemKey: "profile-leave-type",
        //   linkTo: "/profile/leave-type",
        //   labelLocale: t("t_leave_type"),
        //   privilege: [VIEW_LEAVE_TYPE],
        // },
      ],
    },
    // daily_report
    {
      id: "daily-report",
      title: t("t_daily_report"),
      iconSub: HrsolIcons.DailyReportIcon,
      privilege: [
        VIEW_DAILY_REPORT,
        VIEW_ALL_DAILY_REPORT,
        VIEW_MY_DAILY_REPORT,
      ],
      childMenu: [
        {
          itemKey: "my-report",
          linkTo: "/daily-report/my-report",
          labelLocale: t("t_my_daily_report"),
          privilege: [VIEW_MY_DAILY_REPORT],
        },
        {
          itemKey: "all-reports",
          linkTo: "/daily-report/all-reports",
          labelLocale: t("t_all_daily_report"),
          privilege: [VIEW_ALL_DAILY_REPORT],
          functionCode: "all_daily_report",
        },
      ],
    },
  ];
};

export default menuSider;
